export const authConstants = {
    AUTH_LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
    AUTH_LOGIN_COMPLETE: "AUTH_LOGIN_COMPLETE",
    AUTH_LOGOUT_REQUEST: "AUTH_LOGOUT_REQUEST",
    AUTH_LOGOUT_COMPLETE: "AUTH_LOGOUT_COMPLETE",

    AUTH_USER_PROFILE_DEATAILS_REQUEST: "AUTH_USER_PROFILE_DEATAILS_REQUEST",
    AUTH_USER_PROFILE_DEATAILS_COMPLETE: "AUTH_USER_PROFILE_DEATAILS_COMPLETE",

    AUTH_GET_REFRESH_TOKEN_REQUEST: "AUTH_GET_REFRESH_TOKEN_REQUEST",
    AUTH_GET_REFRESH_TOKEN_COMPLETE: "AUTH_GET_REFRESH_TOKEN_COMPLETE",

    PRE_REGISTRATION_REQUEST: "PRE_REGISTRATION_REQUEST",
    PRE_REGISTRATION_COMPLETE: "PRE_REGISTRATION_COMPLETE",

    PRE_REGISTRATION_ACTIVATE_REQUEST: "PRE_REGISTRATION_ACTIVATE_REQUEST",
    PRE_REGISTRATION_ACTIVATE_COMPLETE: "PRE_REGISTRATION_ACTIVATE_COMPLETE",

    FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST:
        "FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST",
    FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE:
        "FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE",

    FORGOT_PASSWORD_RESET_PASSWORD_REQUEST:
        "FORGOT_PASSWORD_RESET_PASSWORD_REQUEST",
    FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE:
        "FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE",

    SEND_OTP_REQUEST: "SEND_OTP_REQUEST",
    SEND_OTP_COMPLETE: "SEND_OTP_COMPLETE",

    RE_SEND_OTP_REQUEST: "RE_SEND_OTP_REQUEST",
    RE_SEND_OTP_COMPLETE: "RE_SEND_OTP_COMPLETE",

    AUTH_CHANGE_PASSWORD_PRE_AUTH_DETAILS:
        "AUTH_CHANGE_PASSWORD_PRE_AUTH_DETAILS",

    AUTH_CHANGE_PASSWORD_REQUEST: "AUTH_CHANGE_PASSWORD_REQUEST",
    AUTH_CHANGE_PASSWORD_COMPLETE: "AUTH_CHANGE_PASSWORD_COMPLETE",

    AUTH_SEND_OTP_AFTER_LOGIN_REQUEST: "AUTH_SEND_OTP_AFTER_LOGIN_REQUEST",
    AUTH_SEND_OTP_AFTER_LOGIN_COMPLETE: "AUTH_SEND_OTP_AFTER_LOGIN_COMPLETE",

    SEND_OTP_CHANGE_PASSWORD: "SEND_OTP_CHANGE_PASSWORD",
    CHANGE_PASSWORD: "CHANGE_PASSWORD",
    CHANGE_MOBILE_NUMBER: "CHANGE_MOBILE_NUMBER",
    SEND_OTP_CHANGE_MOBILE_NUMBER: "SEND_OTP_CHANGE_MOBILE_NUMBER",

    AUTH_CHANGE_PROFILE_PICTURE_REQUEST: "AUTH_CHANGE_PROFILE_PICTURE_REQUEST",
    AUTH_CHANGE_PROFILE_PICTURE_COMPLETE:
        "AUTH_CHANGE_PROFILE_PICTURE_COMPLETE",

    AUTH_CHANGE_NOTIFICATION_REQUEST: "AUTH_CHANGE_NOTIFICATION_REQUEST",
    AUTH_CHANGE_NOTIFICATION_COMPLETE: "AUTH_CHANGE_NOTIFICATION_COMPLETE",

    AUTH_CHANGE_MOBILE_NUMBER_REQUEST: "AUTH_CHANGE_MOBILE_NUMBER_REQUEST",
    AUTH_CHANGE_MOBILE_NUMBER_COMPLETE: "AUTH_CHANGE_MOBILE_NUMBER_COMPLETE",
    AUTH_CHANGE_MOBILE_NUMBER_PRE_MOBILE_DETAILS:
        "AUTH_CHANGE_MOBILE_NUMBER_PRE_MOBILE_DETAILS",

    AUTH_CHANGE_HOME_ADDRESS_REQUEST: "AUTH_CHANGE_HOME_ADDRESS_REQUEST",
    AUTH_CHANGE_HOME_ADDRESS_COMPLETE: "AUTH_CHANGE_HOME_ADDRESS_COMPLETE",

    AUTH_CHANGE_PROFILE_NAME_REQUEST: "AUTH_CHANGE_PROFILE_NAME_REQUEST",
    AUTH_CHANGE_PROFILE_NAME_COMPLETE: "AUTH_CHANGE_PROFILE_NAME_COMPLETE",

    AUTH_GET_USER_DETAILS_REQUEST: "AUTH_GET_USER_DETAILS_REQUEST",
    AUTH_GET_USER_DETAILS_COMPLETE: "AUTH_GET_USER_DETAILS_COMPLETE",

    AUTH_GET_PARTICIPANT_PROFILE_REQUEST:
        "AUTH_GET_PARTICIPANT_PROFILE_REQUEST",
    AUTH_GET_PARTICIPANT_PROFILE_COMPLETE:
        "AUTH_GET_PARTICIPANT_PROFILE_COMPLETE",

    AUTH_SUBSCRIBE_REQUEST: "AUTH_SUBSCRIBE_REQUEST",
    AUTH_SUBSCRIBE_COMPLETE: "AUTH_SUBSCRIBE_COMPLETE",

    AUTH_SELECT_DEALER_SHIP: "AUTH_SELECT_DEALER_SHIP",

    AUTH_USER_DEVICE_REQUEST:'AUTH_USER_DEVICE_REQUEST',
    AUTH_USER_DEVICE_COMPLETE:'AUTH_USER_DEVICE_COMPLETE'
};

export const cookieConstants = {
    USER_DETAILS_COOKIE: "user",
    IS_LOGGED_IN: "is-logged-in",
    USER_NAME: "user_name",
};

export const otpTypeConstants = {
    AUTH_TYPE_LOGIN: 1,
    AUTH_TYPE_FOGOT_PASSWORD: 2,
    AUTH_TYPE_ACCOUNT_ACTIVATION: 4,
    AUTH_TYPE_CHANGE_PASSWORD: 5,
    AUTH_TYPE_CHANGE_MOBILE_NUMBER: 5,
    AUTH_TYPE_ADD_ACCOUNT: 5,
};

export const participantUrl = {
    EQUIPE_URL: process.env.EQUIPE_URL,
    RENAULT_TLC_URL: process.env.RENAULT_TLC_URL,
};

export const participantTypeIds = {
    PARTICIPANT: 13,
    TLC_PARTICIPANT: 14,
};

export const participantJobRoleIds = {
    PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER: 15,
    PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR: 14,
    PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER: 20,
    PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER: 23,
    PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER:24,
    TLC_PARTICIPANT_CUSTOMER: 21,
    TLC_PARTICIPANT_AREA_MANAGER: 22,
    TLC_TRADE_REP:25
};

export const themeType = {
    RENAULT: "de5b2093-01b7-40d0-afc9-c091e52dbddb",
    SHERBET: "de5b2093-01b7-40d0-afc9-c091e52dbddb-s",   
};

export const themeUrl = {
    SHERBET_URL: "https://sherbetrewards.com"
};